// extracted by mini-css-extract-plugin
export var fileExt = "_so-8";
export var fileIcon = "_so-6";
export var fileLink = "_so-5";
export var fileName = "_so-7";
export var image = "_so-1";
export var imageError = "_so-3";
export var imageErrorIcon = "_so-4";
export var imageLink = "_so-0";
export var imageLoaded = "_so-2";